<ion-content>
  <article class="product">
    <!-- Cuadradas, como en la vitrina, deslizables con el dedo. Sin foto, no se dibuja ninguna. -->
    <div class="product-photos" *ngIf="photos.length">
      <div class="photo-track" (scroll)="onPhotosScroll($event)">
        <img *ngFor="let url of photos; let i = index" class="product-photo" [src]="url" alt="" />
      </div>
      <p class="photo-dots" *ngIf="photos.length > 1">
        <span class="visually-hidden">{{ 'Photo' | translate }} {{ photoIndex + 1 }} / {{ photos.length }}</span>
        <span
          *ngFor="let url of photos; let i = index"
          class="photo-dot"
          [class.active]="i === photoIndex"
          aria-hidden="true"
        ></span>
      </p>
    </div>
    <h2 class="product-name">{{ productName }}</h2>
    <p class="product-desc" *ngIf="desc">{{ desc }}</p>
    <p class="product-price" *ngIf="priceText">{{ priceText }}</p>
  </article>

  <section class="group" *ngFor="let group of groups; trackBy: trackById">
    <h3 class="group-name">{{ group.name }}</h3>
    <ion-radio-group *ngIf="isSingle(group); else several">
      <ion-item *ngFor="let option of group.options; trackBy: trackById" [disabled]="!option.available">
        <ion-radio [value]="option.id" justify="space-between">
          <span class="option-name">{{ option.name }}</span>
          <span class="option-price">{{ optionPrice(group, option) }}</span>
        </ion-radio>
      </ion-item>
    </ion-radio-group>
    <ng-template #several>
      <ion-item *ngFor="let option of group.options; trackBy: trackById" [disabled]="!option.available">
        <ion-checkbox justify="space-between">
          <span class="option-name">{{ option.name }}</span>
          <span class="option-price">{{ optionPrice(group, option) }}</span>
        </ion-checkbox>
      </ion-item>
    </ng-template>
  </section>
</ion-content>

<ion-footer class="preview-footer">
  <ion-toolbar>
    <ion-button class="close-preview" expand="block" (click)="closeIt()">{{ 'Close preview' | translate }}</ion-button>
  </ion-toolbar>
</ion-footer>
